export default __webpack_public_path__ + "static/media/contact.9ea8b801.svg";